<template>
  <div ref="mainDiv" class="columnFullScreen" id="chartResultId">
    <div v-if="hasDataErrors" class="error-notification">
      <div class="notification is-warning">
        <p><strong>Attention :</strong> Des problèmes ont été détectés avec les données de cet exercice.</p>
        <ul v-if="shouldShowDetailedErrors">
          <li v-for="(error, index) in validationErrors" :key="index">{{ error }}</li>
        </ul>
        <p v-else>Les valeurs de cohérence cardiaque semblent incorrectes ou manquantes.</p>
        <button class="button is-small" @click="shouldShowDetailedErrors = !shouldShowDetailedErrors">
          {{ shouldShowDetailedErrors ? 'Masquer les détails' : 'Afficher les détails' }}
        </button>
      </div>
    </div>

    <div class="columns is-multiline">
      <!-- <button class="chart-button-fullscreen" v-on:click="toggleFullScreen()">Afficher en plein écran le graphique</button> -->

      <div class="column is-11 is-offset-custom">
        <div class="card-relecture chart-result">
          <!-- <chartFcVue
            :valeurX="validatedProps.valeurX"
            :tabRowFc="validatedProps.TabRowFC"
            :defaultOpenedDetails="DefaultOpenedDetails"
          /> -->
          <chartBiofeedback
            :valeurX="validatedProps.valeurX"
            :tabRowFc="validatedProps.TabRowFC"
            :tabRowCC="validatedProps.TabRowCC"
            :defaultOpenedDetails="DefaultOpenedDetails"
          />
        </div>
      </div>
      <div class="column is-11 is-offset-custom">
        <!-- <div class="chart-result card-relecture">
          <chartAni
            :valeurX="validatedProps.ValeurCCX"
            :tabRowFc="validatedProps.TabRowCC"
            :defaultOpenedDetails="DefaultOpenedDetails"
          />
        </div> -->
      </div>
      <div class="column is-4">
        <div class="circleFCMoyenne1">
          <div class="circleFCMoyenne2">
            <p class="circleFCMoyenne3 has-text-weight-bold">
              <span class="is-size-4">
                {{ Math.round(validatedProps.fcMoyenne || 0) }}
              </span>
              bpm
            </p>
          </div>
        </div>
        <p
          class="has-text-weight-semibold has-text-black has-text-centered is-margin-t-20"
        >
          {{ $t("moyenneFrequenceCardiaque") }}
        </p>
      </div>
      <div class="column is-4">
        <div class="card-relecture card-relecture-info">
          <p>Durée de l'exercice</p>
          <div>
            <p>
              <span class="duration">{{ formatDuration(validatedProps.timeElapsed || 0) }}</span>
              <i class="fas fa-clock logoRelecture"></i>
            </p>
          </div>
        </div>
        <div
          class="card-relecture card-relecture-info"
          style="margin-top: 10px"
        >
          <p>% de temps passé dans chaque zone de cohérences</p>
          <div class="progress-relecture">
            <div
              class="progress-bar-relecture progress-bar-danger-relecture"
              role="progressbar"
              :style="{ width: (validatedProps.Pct1 || 0) + '%' }"
              :class="{ 'black-percentage': validatedProps.Pct1 === 0 }"
              aria-valuenow="redPercentage"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {{ validatedProps.Pct1 || 0 }}%
            </div>
          </div>
          <div class="progress-relecture">
            <div
              class="progress-bar-relecture progress-bar-warning-relecture"
              role="progressbar"
              :style="{ width: (validatedProps.Pct2 || 0) + '%' }"
              :class="{ 'black-percentage': validatedProps.Pct2 === 0 }"
              aria-valuenow="yellowPercentage"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {{ validatedProps.Pct2 || 0 }}%
            </div>
          </div>
          <div class="progress-relecture">
            <div
              class="progress-bar-relecture progress-bar-success-relecture"
              role="progressbar"
              :style="{ width: (validatedProps.Pct3 || 0) + '%' }"
              :class="{ 'black-percentage': validatedProps.Pct3 === 0 }"
              aria-valuenow="greenPercentage"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {{ validatedProps.Pct3 || 0 }}%
            </div>
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="circleFCMoyenne1" :class="{'error-circle': hasCCDataError}">
          <div
            class="circleFCMoyenne4"
            :style="{
              'background-color': validatedProps.couleurCCMoyenne || '#000000',
            }"
          >
            <p class="circleFCMoyenne3 has-text-weight-bold">
              <span v-if="!hasCCDataError" class="is-size-4">
                {{ Math.round(validatedProps.ccMoyenne || 0) + "%" }}
              </span>
              <span v-else class="is-size-6 error-text">
                Données<br>incorrectes
              </span>
            </p>
          </div>
        </div>
        <p
          class="has-text-weight-semibold has-text-black has-text-centered is-margin-t-20"
        >
          Moyenne cohérence
        </p>
      </div>
      <div v-if="comment" class="column is-12">
        <b-field label="commentaire :">
          <b-input
            @input="emitCommentaire"
            maxlength="200"
            type="textarea"
            v-model="commentaireMoniteur"
          ></b-input>
        </b-field>
      </div>
      <div v-if="comment" class="column is-12 containerButtonSave">
        <button class="buttonChart contentButtonSave" v-on:click="emitSave()">
          Sauvegarder
        </button>
      </div>
    </div>
    <!-- <div class="PlacementBoutonFullScreen">
      <button class="BoutonFullScreen" v-on:click="toggleFullscreen()">
        Mettre en plein écran la relecture
      </button>
    </div> -->
  </div>
</template>

<script>
// import suivieCc from "../tableauDeBord/SuivieCcExercice.vue";
import Parse from "parse";
import ParseConfig from "@/api/parse.config";
const User = createNamespacedHelpers("user");
import { createNamespacedHelpers } from "vuex";
// import chartFcVue from "../tableauDeBord/chartFc.vue";
// import chartAni from "../tableauDeBord/chartMoniteur.vue";
import chartBiofeedback from "../tableauDeBord/chartBiofeedback.vue";

export default {
  data() {
    return {
      firstObject: {},
      ouvertureSuiviCcUtilisateur: "",
      fileId: "7rOgxcWOD4",
      protocole: "Entraînement libre",
      userSelected: "tous",
      DisplayRelecture: false,
      commentaireMoniteur: "",
      greenPercentage: 10,
      redPercentage: 20,
      yellowPercentage: 50,
      isFullscreen: false,
      validatedProps: {}, // Stocker les props validées
      validationErrors: [], // Stocker les erreurs de validation
      shouldShowDetailedErrors: false // Contrôle l'affichage détaillé des erreurs
    };
  },
  props: [
    "valeurX",
    "fcMoyenne",
    "ccMoyenne",
    "couleurCCMoyenne",
    "TabRowFC",
    "DefaultOpenedDetails",
    "ValeurCCX",
    "TabRowCC",
    "labelChrono",
    "timeElapsed",
    "comment",
    "Pct1",
    "Pct2",
    "Pct3",
  ],
  components: {
    // suivieCc,
    // chartFcVue,
    // chartAni,
    chartBiofeedback,
  },
  computed: {
    ...User.mapState(["user"]),
    
    // Détecte si les données de cohérence cardiaque sont problématiques
    hasCCDataError() {
      return (
        (this.validatedProps.ccMoyenne === 0 || !this.validatedProps.ccMoyenne) ||
        (Array.isArray(this.validatedProps.TabRowCC) && this.validatedProps.TabRowCC.length === 0)
      );
    },
    
    // Détecte s'il y a des erreurs de données à afficher
    hasDataErrors() {
      return this.validationErrors.length > 0 || this.hasCCDataError;
    }
  },
  created() {
    this.validateProps();
    this.commentaireMoniteur = this.comment;
    console.log("ALL PROPS", this.$props);
  },
  // Surveiller les changements des props pour revalider
  watch: {
    TabRowCC() { this.validateProps(); },
    ValeurCCX() { this.validateProps(); },
    TabRowFC() { this.validateProps(); },
    fcMoyenne() { this.validateProps(); },
    ccMoyenne() { this.validateProps(); },
    couleurCCMoyenne() { this.validateProps(); },
    timeElapsed() { this.validateProps(); },
    Pct1() { this.validateProps(); },
    Pct2() { this.validateProps(); },
    Pct3() { this.validateProps(); }
  },
  methods: {
    toggleFullScreen() {
      let element = document.getElementById("chartResultId");
      if (!document.fullscreenElement) {
        element.requestFullscreen().catch((err) => {
          alert(
            `Erreur lors de la tentative de passage en plein écran: ${err.message} (${err.name})`
          );
        });
        this.isFullScreen = true; // Mettre à jour l'état en plein écran
      } else {
        document.exitFullscreen();
      }
    },
    validateProps() {
      this.validationErrors = [];
      this.validatedProps = { ...this.$props }; // Copie initiale

      // Validation des pourcentages
      ["Pct1", "Pct2", "Pct3", "ccMoyenne", "fcMoyenne"].forEach((propName) => {
        const value = this.$props[propName];
        if (typeof value !== "number" || value < 0 || value > 100) {
          this.validationErrors.push(
            `${propName} doit être un pourcentage entre 0 et 100, reçu: ${value}`
          );
          this.validatedProps[propName] = 0; // Valeur par défaut
        }
      });

      // Validation de la couleur
      if (
        !/^#([0-9A-F]{3}){1,2}$/i.test(this.couleurCCMoyenne) &&
        !/^rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)$/i.test(
          this.couleurCCMoyenne
        ) &&
        !/^rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*[\d.]+\s*\)$/i.test(
          this.couleurCCMoyenne
        )
      ) {
        this.validationErrors.push(
          `couleurCCMoyenne doit être une couleur valide, reçu: ${this.couleurCCMoyenne}`
        );
        this.validatedProps.couleurCCMoyenne = "#000000"; // couleur par défaut
      }

      // Validation du temps écoulé
      if (typeof this.timeElapsed !== "number" || this.timeElapsed < 0) {
        this.validationErrors.push(
          `timeElapsed doit être un nombre positif, reçu: ${this.timeElapsed}`
        );
        this.validatedProps.timeElapsed = 0;
      }

      // Validation et nettoyage des tableaux TabRowCC et ValeurCCX
      if (Array.isArray(this.TabRowCC) && Array.isArray(this.ValeurCCX)) {
        const cleanedCC = [];
        const cleanedCCX = [];

        // S'assurer qu'ils ont la même longueur
        const minLength = Math.min(this.TabRowCC.length, this.ValeurCCX.length);

        for (let i = 0; i < minLength; i++) {
          const ccValue = this.TabRowCC[i];

          // Vérifier si la valeur CC est valide (entre 0 et 100, non nulle)
          if (typeof ccValue === "number" && ccValue > 0 && ccValue <= 100) {
            cleanedCC.push(ccValue);
            cleanedCCX.push(this.ValeurCCX[i]);
          } else {
            this.validationErrors.push(
              `TabRowCC[${i}] invalide: ${ccValue}. Doit être entre 0 et 100 et non nul.`
            );
          }
        }

        this.validatedProps.TabRowCC = cleanedCC;
        this.validatedProps.ValeurCCX = cleanedCCX;
        
        // Ajouter une erreur spécifique si toutes les données CC ont été supprimées
        if (cleanedCC.length === 0 && this.TabRowCC.length > 0) {
          this.validationErrors.push(
            `Aucune donnée de cohérence cardiaque valide n'a été trouvée sur les ${this.TabRowCC.length} mesures.`
          );
        }
      } else {
        this.validationErrors.push(
          "TabRowCC et ValeurCCX doivent être des tableaux"
        );
        this.validatedProps.TabRowCC = [];
        this.validatedProps.ValeurCCX = [];
      }

      // Validation de TabRowFC (valeurs BPM)
      if (Array.isArray(this.TabRowFC)) {
        const cleanedFC = [];

        for (let i = 0; i < this.TabRowFC.length; i++) {
          const fcValue = this.TabRowFC[i];

          if (typeof fcValue === "number" && fcValue >= 30 && fcValue <= 180) {
            cleanedFC.push(fcValue);
          } else {
            this.validationErrors.push(
              `TabRowFC[${i}] invalide: ${fcValue}. Doit être entre 30 et 180 BPM.`
            );
          }
        }

        this.validatedProps.TabRowFC = cleanedFC;
        
        // Ajouter une erreur si toutes les données FC ont été supprimées
        if (cleanedFC.length === 0 && this.TabRowFC.length > 0) {
          this.validationErrors.push(
            `Aucune donnée de fréquence cardiaque valide n'a été trouvée sur les ${this.TabRowFC.length} mesures.`
          );
        }
      } else {
        this.validationErrors.push("TabRowFC doit être un tableau");
        this.validatedProps.TabRowFC = [];
      }

      // Afficher les erreurs dans la console
      if (this.validationErrors.length > 0) {
        console.warn("Erreurs de validation des props:", this.validationErrors);
      }
    },
    formatDuration(seconds) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      if (
        (remainingSeconds === 1 && minutes === 0) ||
        (remainingSeconds === 5 && minutes === 0)
      ) {
        return `${remainingSeconds}min${minutes}s`;
      } else {
        return `${minutes}min${remainingSeconds}s`;
      }
    },
    toggleFullscreen() {
      if (!document.fullscreenElement) {
        this.$refs.mainDiv
          .requestFullscreen()
          .then(() => {
            this.isFullscreen = true;
          })
          .catch((err) => {
            alert(
              `Erreur en tentant de passer en mode plein écran: ${err.message} (${err.name})`
            );
          });
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen().then(() => {
            this.isFullscreen = false;
          });
        }
      }
    },
    emitSave() {
      this.$emit("save-change", this.commentaireMoniteur);
    },
    emitCommentaire() {
      this.$emit("commentaire-change", this.commentaireMoniteur);
    },
  },

  mounted() {
    ParseConfig();
    const objectFolder = Parse.Object.extend("folder");
    const QueryFolders = new Parse.Query(objectFolder);
    QueryFolders.equalTo("objectId", "ALoaWJgV7l");
    QueryFolders.find().then((results) => {
      this.folders = results;
      this.firstObject = this.folders.shift();
      return this.folders, this.firstObject;
    });
  },
};
</script>
<style>
.encadrement {
  margin: 0 auto;
  padding: 8px;
  /* background-color: rgba(0, 0, 0, 0.5); */
}
.containerButtonSave {
  display: flex;
  align-items: center;
  justify-content: center;
}
.contentButtonSave {
  text-align: center;
}
.unit {
  font-size: 0.8em;
  color: #888;
}
.logoRelecture {
  margin-left: 10px;
}
.animated-timer {
  font-size: 3em;
  animation: pulse 1s infinite alternate;
}

@keyframes pulse {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.2);
  }
}
.card-relecture {
  background-color: #f5f5f5;
  border-radius: 5px;
  /* padding: 10px; */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.black-percentage {
  color: black !important;
}

.buttonChart {
  text-decoration: none;
  text-transform: none;
  padding: 10px;
  min-height: 40px;
  border-radius: 20px;
  border: 0 none;
  outline: 0 none;
  -webkit-appearance: button;
  cursor: pointer;
  background-color: rgb(35, 147, 128) !important;
  color: white;
  margin: 7px;
}
.PlacementBoutonFullScreen {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.BoutonFullScreen {
  background-color: rgb(35, 147, 128) !important;
  color: white;
  border-radius: 5px;
  border: 0 none;
  outline: 0 none;
  -webkit-appearance: button;
  cursor: pointer;
  padding: 5px;
  margin-left: auto;
}
.is-offset-custom {
  margin-left: 4.1666%;
}
.card-relecture {
  background-color: #f5f5f5;
  border-radius: 5px;
  /* padding: 10px; */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.card-relecture-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.progress-relecture {
  height: 20px;
  margin-bottom: 10px;
  overflow: hidden;
  background-color: #f5f5f5;
  border-radius: 4px;
  border: 1px solid #ccc;
  width: 100%;
}

.progress-bar-relecture {
  height: 100%;
  /* color: #fff; */
  text-align: center;
  white-space: nowrap;
  transition: width 0.6s ease;
}

.progress-bar-success-relecture {
  background-color: #28a745;
}

.progress-bar-danger-relecture {
  background-color: #dc3545;
}

.progress-bar-warning-relecture {
  background-color: #ffc107;
}
.columnFullScreen {
  /* overflow-y:auto; */
}

.chart-button-fullscreen {
  background-color: #239380; /* Green background */
  color: white; /* White text */
  padding: 6px 12px; /* Padding around the text */
  font-size: 12px; /* Button text size */
  border: none; /* No borders */
  border-radius: 5px; /* Rounded corners */
  cursor: pointer; /* Pointer cursor on hover */
  transition: background-color 0.3s, transform 0.3s; /* Smooth transition for hover effects */
  display: inline-flex; /* Flexbox for inline alignment */
  align-items: center; /* Center items vertically */
  justify-content: center; /* Center text and icon horizontally */
  margin-bottom: 1rem; /* Add some space below the button */
  margin-left: auto;
  display: flex;
  margin-right: 1rem;
  margin-top: 1rem;
}

#chartResultId {
  background-color: white;
}

.error-notification {
  margin-bottom: 20px;
  margin-top: 10px;
  width: 100%;
  padding: 0 1.5rem;
}

.error-circle {
  position: relative;
}

.error-circle::after {
  content: "!";
  position: absolute;
  top: -10px;
  right: -10px;
  width: 25px;
  height: 25px;
  background-color: #ff3860;
  border-radius: 50%;
  color: white;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
}

.error-text {
  color: #ff3860;
  font-weight: bold;
  line-height: 1.2;
}
</style>
